@if (loadStatus() === "loading" || loadStatus() === "idle") {
  <div class="flex justify-center py-16">
    <span class="material-icons animate-spin text-[#5a2f6b]" aria-hidden="true">progress_activity</span>
  </div>
} @else if (loadStatus() === "error") {
  <div class="rounded-xl border border-destructive/20 bg-destructive/5 p-4 text-center">
    <p class="text-sm text-destructive">{{ "mobile.eachat.wizard.loadError" | translate }}</p>
    <button
      type="button"
      class="mt-4 rounded-full bg-[#5a2f6b] px-5 py-2.5 text-sm font-bold text-white"
      (click)="backToList()"
    >
      {{ "mobile.eachat.wizard.backToList" | translate }}
    </button>
  </div>
} @else {
  @let draftTicket = draft();
  @if (draftTicket) {
  <mobile-module-tab
    [config]="ticketModuleConfig() ?? undefined"
    (closeRequested)="backToList()"
    [showWizardNavigation]="true"
    [wizardInstanceId]="mobileWizardInstanceId()"
    [isNavigating]="saveStatus() === 'saving'"
    [isSaving]="saveStatus() === 'saving'"
    [allowSubmit]="canSubmitTicket()"
    [allowSaveAsDraft]="ticketAccess().hasCreateAccess"
    (wizardPrevious)="previous()"
    (wizardNext)="next()"
    (wizardSaveAsDraft)="saveAsDraft()"
    (wizardSubmit)="save()"
  >
    <div
      class="flex flex-col gap-4 pb-2"
      [class.pointer-events-none]="ticketFormReadOnly()"
      [class.opacity-75]="ticketFormReadOnly()"
    >
      <div class="min-w-0 overflow-hidden rounded-xl border border-[#ece4f3] bg-[#faf7fc] px-5 py-3 shadow-sm">
        <h3 class="mb-2.5 border-b border-[#ece4f3] pb-2 text-[0.72rem] font-bold uppercase tracking-wide text-[#5a2f6b]">
          {{ "mobile.eachat.wizard.requestContextTitle" | translate }}
        </h3>
        <dl class="grid gap-3 text-[0.8rem] leading-snug text-[#3d2652]">
          <div class="flex min-w-0 justify-between gap-3">
            <dt class="shrink-0 text-[#7a6b8a]">{{ "mobile.eachat.field.demande" | translate }}</dt>
            <dd class="min-w-0 max-w-[55%] truncate pl-2 pr-3 text-right font-semibold italic text-[#1a1523]">
              {{ draftTicket.Label?.trim() || ("mobile.eachat.list.unnamed" | translate) }}
            </dd>
          </div>
          <div class="flex min-w-0 justify-between gap-3">
            <dt class="shrink-0 text-[#7a6b8a]">{{ "mobile.eachat.field.typeColumn" | translate }}</dt>
            <dd class="min-w-0 max-w-[55%] truncate pl-2 pr-3 text-right font-semibold italic text-[#1a1523]">
              {{ ticketTypeColumnLabel(draftTicket) }}
            </dd>
          </div>
          <div class="demand-list-field-row min-w-0 items-start">
            <dt class="demand-list-field-label pt-2">{{ "mobile.eachat.field.requester" | translate }}</dt>
            <dd class="flex min-w-0 items-center justify-end gap-2.5">
              <span
                class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#5a2f6b] text-[0.72rem] font-bold tracking-tight text-white"
                aria-hidden="true"
                >{{ ticketRequesterInitials(draftTicket) }}</span
              >
              <div class="min-w-0 max-w-full flex-1 text-right">
                <p class="truncate text-sm font-semibold text-[#1a1523]">
                  {{ mobileTicketRequesterLabel(draftTicket) || ("app.shared.notprovided" | translate) }}
                </p>
                @if (draftTicket.TicketType) {
                  <p class="mt-0.5 flex items-center justify-end gap-1 text-[0.7rem] italic text-[#7a6b8a]">
                    <span class="material-icons shrink-0 text-[14px]" aria-hidden="true">{{
                      mobileTicketTypeMaterialIcon(draftTicket)
                    }}</span>
                    <span class="min-w-0 truncate">{{ mobileTicketTypeDisplayLabel(draftTicket) }}</span>
                  </p>
                }
              </div>
            </dd>
          </div>
        </dl>
      </div>

      @switch (currentStepKey()) {
        @case ("general") {
          <mobile-ticket-general-info-step [wizard]="ticketWizardHost" [ticket]="draftTicket" />
        }
        @case ("products") {
          <mobile-ticket-product-selection-step [wizard]="ticketWizardHost" />
        }
        @case ("equipment-types") {
          <mobile-ticket-vehicle-types-step [wizard]="ticketWizardHost" [ticket]="draftTicket" />
        }
        @case ("equipment-selection") {
          <mobile-ticket-vehicle-selection-step [wizard]="ticketWizardHost" [ticket]="draftTicket" />
        }
      @case ("address") {
        <mobile-ticket-delivery-address-step [wizard]="ticketWizardHost" [ticket]="draftTicket" />
      }
      @case ("summary") {
        <mobile-ticket-summary-step
          [wizard]="ticketWizardHost"
          [ticket]="draftTicket"
          [saveHadError]="saveStatus() === 'error'"
        />
      }
    }
    </div>
  </mobile-module-tab>
  @if (productDetailProductUid(); as productUid) {
    <mobile-product-detail-sheet
      [productUid]="productUid"
      [productPreview]="productDetailPreview()"
      (closed)="closeProductDetail()"
      (saved)="onProductDetailSaved($event)"
    />
  }
  }
}
